module.exports = __webpack_public_path__ + "static/media/img-notfound.1f5dfaad.png";